import axios from "axios";

export const state = {
  todos: [],
  tabIndex: false,
};

export const getters = {
  todos: (state) => state.todos,
  tabIndex: (state) => state.tabIndex,
};

export const mutations = {
  setTodos(state, newValue) {
    state.todos = newValue;
  },
  setTabIndex(state) {
    state.tabIndex = !state.tabIndex;
  },
};

export const actions = {
  fetchTodos({ commit }) {
    axios.get("https://jsonplaceholder.typicode.com/todos").then((res) => {
      commit("setTodos", res.data);
    });
  },
  changeTabIndex({ commit }) {
    console.log("changed");
    commit("setTabIndex");
  },
};
